<template>
    <div>
        Route fee internal
    </div>
</template>

<script setup lang="ts"></script>
